module.exports = __webpack_public_path__ + "static/media/view_more.b52cf8c1.svg";